import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    name: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the asset name input field */
            name: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetNameRow.name?c=225ge594d9ejj", defaultMessage: "Name" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
